/* ============================================================
   DEELITE — habillage néon : la progression de lecture

   Une seule chose demande du JavaScript ici : le rail de gauche
   qui se remplit au fil du scroll.

   Les deux cercles du bloc DON'T STOP tournent désormais en CSS
   pur, tout seuls. Les faire tourner au scroll obligeait à lire
   leur position puis à réécrire leur transformation à chaque
   image — c'est ce qui faisait ramer le défilement.

   Attention : l'attribut du rail est data-dnl-rail-progress, et
   non data-dnl-progress, qui appartient déjà à la fine barre jaune
   horizontale en haut de page (gérée par deelite.js).
   ============================================================ */
(function () {
  if (window.DNL_NEON) return;
  window.DNL_NEON = true;

  var fills = [];
  var ticking = false;
  var last = "";
  var max = 0;

  function collect() {
    fills = document.querySelectorAll("[data-dnl-rail-progress]");
  }

  // La hauteur de la page ne bouge pas pendant qu'on fait defiler :
  // on la mesure une fois pour toutes, sinon on forcerait le navigateur
  // a recalculer la mise en page a chaque image.
  function measure() {
    max = document.documentElement.scrollHeight - window.innerHeight;
  }

  function update() {
    ticking = false;
    if (!fills.length) return;

    var ratio = max > 0 ? window.pageYOffset / max : 0;
    if (ratio < 0) ratio = 0;
    if (ratio > 1) ratio = 1;

    // on n'écrit que si la valeur a vraiment bougé : inutile de
    // redéclencher une mise en page pour un dixième de pour cent
    var value = (ratio * 100).toFixed(1) + "%";
    if (value === last) return;
    last = value;

    for (var i = 0; i < fills.length; i++) fills[i].style.height = value;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function start() {
    collect();
    measure();
    last = "";
    update();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", start, { passive: true });
  window.addEventListener("load", start);

  document.addEventListener("shopify:section:load", function () {
    setTimeout(start, 60);
  });
})();
